﻿function regex(value, $field, required) {
	return $field.is("[data-regex]") ? !!value.match($field.attr("data-regex")) : false;
}